﻿import window from 'window';

import { loadModules } from './foundation/moduleInitializer';

import { browserDetect } from './utilities/browser-detect';
import { mouseEventPolyfill } from './foundation/mouseEventPolyfill';

import { contactPreferences } from './feature/accounts/contact-preferences';
import { accountRegistration } from './feature/accounts/account-registration';
import { finishRegistration } from './feature/accounts/finish-registration';
import { marketingPreferencesRebrand } from './feature/accounts/register-marketing-preferences';
import { revealPassword } from './feature/accounts/reveal-password';

import { bankAccountLookup } from './feature/order/bank-account-lookup';
import { downloadAgreement } from './feature/order/download-agreement';
import { postcodeLookup } from './feature/order/postcode-lookup';
import { requestPrice } from './feature/order/request-price';
import { stepIndicator } from './feature/order/step-indicator';
import { renewalModal } from './feature/order/renewal-modal';
import { driverValidation} from './feature/order/guarantor-details';

import { anchorList } from './feature/page-content/anchor-list';
import { contentToggle } from './feature/page-content/content-toggle';
import { faqAccordion } from './feature/page-content/page-accordion';
import { whyUsCarousel } from './feature/page-content/why-us-carousel';
import { journeyHeroBanner } from './feature/page-content/journey-hero-banner';
import { cardsPagination } from './feature/navigation/cards-pagination';
import { widgetToggle } from './feature/page-content/widget-toggle';

import { enableFormSubmission } from './feature/form/enable-form';
import { runtimeFormValidation } from './feature/form/handle-runtime-validation';
import { emailPrepopulateQuery } from './feature/form/prepopulate-email';
import { handleKeyInput } from './feature/form/handle-key-input';
import { tracking } from './feature/marketing/tracking';

import { webchat } from './feature/webchat/webchat';
import { addressHandler } from './feature/scc/address-handler';

import { conditionHandler } from './feature/contact/condition-handler';
import { gtmEventHandler } from './feature/form/gtm-event-handler';
import { travelDocuments } from './feature/accounts/travel-documents';
import { cookieConsent } from './feature/page-content/cookie-consent';
import { usageType } from './feature/usagetype/usagetype';
import { address } from './feature/order/address';

import { specialOffers } from './feature/offers/special-offers';
import { marketingModal } from './feature/marketing/marketing-modal';

import { budgetRangeSelector } from './feature/search/budgetRangeSelector';

const app = (function() {
    const modules = [
        browserDetect,
        mouseEventPolyfill,
        anchorList,
        bankAccountLookup,
        emailPrepopulateQuery,
        postcodeLookup,
        address,
        enableFormSubmission,
        runtimeFormValidation,
        faqAccordion,
        revealPassword,
        requestPrice,
        stepIndicator,
        contentToggle,
        downloadAgreement,
        marketingPreferencesRebrand,
        contactPreferences,
        webchat,
        cardsPagination,
        widgetToggle,
        tracking,
        addressHandler,
        conditionHandler,
        whyUsCarousel,
        handleKeyInput,
        journeyHeroBanner,
        accountRegistration,
        finishRegistration,
        gtmEventHandler,
        renewalModal,
        travelDocuments, 
        cookieConsent,
        usageType,
        driverValidation,
        specialOffers,
        marketingModal,
        budgetRangeSelector
    ];

    return {
        init() {
            loadModules(modules);
        }
    };
})();

window.addEventListener('DOMContentLoaded', app.init);